export default __webpack_public_path__ + "static/media/movie-icon.13311048.svg";